<template>
  <div class="otodetrmflzx">
    <div class="lantit">热门法律咨询</div>
    <div class="xgllist between wrap">
      <div class="xglitem ellipsis" v-for="item in 6" :key="item">
        孩子玩迷你世界充值4650能退回吗... 
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.otodetrmflzx {
  width: 100%;
  height: 100%;
  padding: 40px;
  box-shadow: 0px 0px 8px 0px rgba(1, 1, 1, 0.08);
  border-radius: 2px;
  .lantit {
    color: #333333;
    font-size: 22px;
  }
  .xgllist {
    align-items: flex-start;
    color: #333;
    padding-top: 10px;
    .xglitem {
      font-size: 14px;
      line-height: 14px;
      margin-top: 21px;
      width: 30%;
      color: #666666;
      cursor: pointer;
      &:hover {
        color: #0465ea;
      }
    }
  }
}
</style>